import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestExchangeCardList = ({ csrfToken, postParams, pageNumber }) => {
  let getUrl = '/user/exchange_card/list';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.post(
    getUrl,
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestExchangeCardCheck = ({ csrfToken, postParams }) => {
  const getUrl = '/user/exchange_card/check';
  const result = apiClient.post(
    getUrl,
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestExchangeCardExchange = ({ csrfToken, postParams }) => {
  const getUrl = '/user/exchange_card/exchange';
  const result = apiClient.post(
    getUrl,
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestExchangeCardList,
  requestExchangeCardCheck,
  requestExchangeCardExchange,
};
